// Elemntos html
const btnScroll = document.querySelector<HTMLButtonElement>('#btn-scroll')!;

// Variables externas
const windowsEvents = ['scroll', 'resize', 'DOMContentLoaded'];

/**
 *
 */
export function main() {
  // Eventos para aparecer el boton de ir hacia arriba
  windowsEvents.forEach((event) =>
    window.addEventListener(event, () => {
      const downPx = 200; // Medida de cuentos PX debe bajar el cliente
      if (window.scrollY > downPx) btnScroll.classList.remove('d-none');
      else btnScroll.classList.add('d-none');
    })
  );
  btnScroll.addEventListener('click', () =>
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  );
}
